import React, { useEffect, useState, useRef } from 'react'
import { useSelector } from 'react-redux';
import { Calendar } from "primereact/calendar";
import { selectData } from '../../../services/store/userSlice';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { timesheetApi } from '../../../services';
import { Dropdown } from 'primereact/dropdown';
import { leaveService } from '../../../services/extensions';
import { Status, LeaveStatus, LeaveStatusCode } from '../../../common/util/constants';
import { useLocation } from 'react-router-dom';
import { Util } from '../../../services';
import { toast } from "react-toastify";
import { Dialog } from 'primereact/dialog';
import { utitService } from '../../../services/util';
import '../styles/user-leave.scss';
import { selectUser } from '../../../services/store/userSlice';
import { ViewLeave } from './view-leave';
import ConfirmBox from '../../../components/confirmbox/confirmbox';
import moment from 'moment';


const UserLeaves = ({ selectedUser, isDialog }) => {
    const userData = useSelector(selectData);
    const dt = useRef(null);
    const [usersBySuperior, setUsersBySuperior] = useState([]);
    // const [selectedUser, setSelectedUser] = useState({});
    const [selectedLeave, setSelectedLeave] = useState([]);
    const [approvedLeavesByEmp, setApprovedLeavesByEmp] = useState([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const userId = searchParams.get('id');
    const [reviewRecallLeaves, setReviewRecallLeaves] = useState([]);
    const [selStatus, setSelStatus] = useState('REVIEW');
    const [leaves, setLeaves] = useState([]);
    const [leaveStatuses] = useState(Object.keys(LeaveStatus));
    const [selLeaves, setSelLeaves] = useState({});
    const [viewDialog, setViewDialog] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [action, setAction] = useState('');
    const [viewTabIndex, setViewTabIndex] = useState(0);
    const [duration, setDuration] = useState(new Date());

    useEffect(() => {
        if (selectedUser !== null) {
            fetchReviewLeavesByUser(selectedUser.id);
        }

    }, [selectedUser, duration])


    const fetchReviewLeavesByUser = () => {
        leaveService.getAllLeaveByUserId({ id: selectedUser.id, date: moment(duration).format('YYYY-MM-DD') }).then(resp => {
            try {
                setLeaves(resp.data.data);
            } catch (error) {
                //error
            }
        })
    };

    //fetch approved leaves by user
    const fetchApprovedLeavesByUser = () => {
        leaveService.getApprovedLeaves(selectedUser?.id).then(resp => {
            try {
                let approveLeaveArray = []
                approveLeaveArray = resp.data.data?.filter(el => {
                    return el.status === LeaveStatus.APPROVED
                })
                setApprovedLeavesByEmp(approveLeaveArray)
            } catch (error) {
                //error
            }
        })
    };

    //fetch review recalled leaves by user
    const fetchReviewRecallLeaves = () => {
        leaveService.getReviewRecallLeaves(selectedUser?.id).then(resp => {
            try {
                setReviewRecallLeaves(resp.data.data);
            } catch (error) {
                console.log('error');
            }
        })
    }

    /* Users By Superior Data Start */
    const getUserInfoBySuperiorIdList = (param = { "pageNum": 0, "pageSize": 2000 }) => {
        timesheetApi.getUsersBySuperior(param).then((resp) => {
            try {
                const data = resp.data.data;
                const resourceList = data.map((user, index) => ({
                    id: user.id,
                    name: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                    fullName: user.firstName.charAt(0).toUpperCase() + user.firstName.slice(1) + " " + user.lastName.charAt(0).toUpperCase() + user.lastName.slice(1).trimEnd(),
                })
                );
                setUsersBySuperior(resourceList);
                // setSelectedUser(usersBySuperior[0]);
                let activeUser = {};
                if (userId) {
                    activeUser = usersBySuperior.find((i) => i.id === parseInt(userId));
                } else {
                    activeUser = resourceList[0];
                }
                // setSelectedUser(activeUser);
            } catch (error) {
                // Error handle
            }
        });
    }
    /* Users By Superior Data End */


    const renderAbsenceCode = (rowData, options) => {
        return (<>
            <strong>{rowData?.LeaveAbsenceCode?.code}</strong>
            <em> ({rowData?.LeaveAbsenceCode?.title})</em>
        </>)
    }
    const renderAbsenceDuration = (rowData, options) => {
        return (<>
            <strong>{rowData.LeaveType?.code}</strong>
            {rowData.LeaveType && <em> ({rowData.LeaveType?.title})</em>}
        </>)
    }
    const renderReasonOfLeave = (rowData, options) => {
        const reason = rowData.reasonOfLeave || '';
        const txt = reason.substr(0, 200);
        return (<>
            <span className='noet'>{txt}</span>
        </>)
    }

    const viewLeave = (row, tabIndex = 0) => {
        setSelLeaves(row);
        setViewDialog(true);
        setViewTabIndex(tabIndex)
    }

    const renderActions = (rowData, options) => {
        return (
            <div className='action-column'>
                {rowData.attachment !== null && <Button icon="pi pi-link" className="p-button p-button-text p-button-sm p-button-warning p-0 m-0" onClick={() => viewLeave(rowData, 1)} />}
                <Button icon="pi pi-eye" className="p-button-rounded p-button-text" aria-label="Edit" onClick={() => viewLeave(rowData, 0)} />
            </div>
        )
    }
    const updateLeaves = (e) => {
        setAction(e);
        setShowDialog(true)
    }
    const paginatorTmpl = {
        layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
        'RowsPerPageDropdown': (options) => {
            const dropdownOptions = [
                { label: 10, value: 10 },
                { label: 20, value: 20 },
                { label: 50, value: 50 }
            ];

            return (
                <React.Fragment>
                    <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Items per page: </span>
                    <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
                </React.Fragment>
            );
        },
        'CurrentPageReport': (options) => {
            return (

                <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    {options.first} - {options.last} of {options.totalRecords}
                </span>
            )
        }
    }
    const paginationLeft = (e) => {
        return (<div className='ess-header-label pt-1'>


        </div>)
    }


    return (
        <div className='ess-page user-leave p-2'>
            <div className='' style={{ position: 'absolute', marginTop: '-58px', right: '42px' }}>
                <Calendar id="monthpicker" value={duration} onChange={(e) => setDuration(e.value)} view="month" dateFormat="mm-yy" yearNavigator yearRange={"2010:" + new Date().getFullYear().toString()} showIcon />
            </div>
            <div className='grid ess-table' >
                <div className='col p-0 pt-2'>
                    <DataTable
                        className="leaves-data"
                        paginator
                        responsiveLayout="scroll"
                        paginatorLeft={paginationLeft}
                        paginatorTemplate={paginatorTmpl}
                        rows={10}
                        rowsPerPageOptions={[10, 20, 50]}
                        dataKey="id" ref={dt} value={leaves} selection={selectedLeave}
                        onSelectionChange={(e) => setSelectedLeave(e.value)}
                        resizableColumns columnResizeMode="fit" scrollable="horizontal" stripedRows editMode="row"
                        emptyMessage='Please select a user'
                    >
                        <Column field="startDate" header="Date" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateWithMonthConverter(rowData.startDate))} />
                        <Column header="Day" headerStyle={{ width: '100px' }} body={(rowData) => (utitService.dateParser(rowData.startDate, 'dddd'))} />
                        <Column field="absenceCode" header="Absence Code" headerStyle={{ width: '220px' }} body={renderAbsenceCode} />
                        <Column field="leaveType" header="Leave Type" headerStyle={{ width: '180px' }} body={renderAbsenceDuration} />
                        <Column field="reasonOfLeave" header="Reason of leave" body={renderReasonOfLeave} />
                        <Column field="status" header="Status" style={{ width: '100px', textAlign: 'center' }} body={(r) => LeaveStatusCode[r.status]} />
                        <Column header="Actions" headerClassName='center-header' headerStyle={{ width: '50px', textAlign: 'center' }} bodyStyle={{ textAlign: 'right' }} body={renderActions} />
                    </DataTable>
                </div>
            </div>
            {ViewLeave({ visible: viewDialog, onHide: () => setViewDialog(false), style: { width: '900px' }, leave: selLeaves, header: 'Leave Details', tabIndex: viewTabIndex })}
        </div >
    )
}

export default UserLeaves